/* eslint no-console: 0 */
// Run this example by adding <%= javascript_pack_tag 'hello_svelte' %> (and
// <%= stylesheet_pack_tag 'hello_svelte' %> if you have styles in your component)
// to the head of your layout file,
// like app/views/layouts/application.html.erb.
// All it does is render <div>Hello Svelte!</div> at the bottom of the page.

import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'whatwg-fetch'
import 'formdata-polyfill'

import App from '../src/UserIndexWrappedWithModal.svelte'

document.addEventListener('DOMContentLoaded', () => {
  const app = new App({
    target: document.body,
  });

  window.app = app;
})
